export function formatDateTime(input) {
    try {
      if (!input || typeof input !== 'string') return "-";
  
      const date = new Date(input.replace(" ", "T")); // Ensure compatibility with Date constructor
      if (isNaN(date.getTime())) return "-"; // Check if the date is invalid
  
      const options = { month: "short", day: "numeric", year: "numeric" };
      const formattedDate = date.toLocaleDateString("en-US", options);
      const formattedTime = date.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });
  
      return `${formattedDate} at ${formattedTime}`;
    } catch (error) {
      return "-";
    }
  }
  
//   // Example usage:
//   console.log(formatDateTime("2025-02-20 13:38:04")); // Expected output: "Feb 20, 2025 at 1:38 PM"
//   console.log(formatDateTime("invalid input")); // Expected output: "-"
export function formatToShortDate(input) {
    try {
      if (!input || typeof input !== "string") return "-";
  
      const date = new Date(input.replace(" ", "T")); // Ensure compatibility with Date constructor
      if (isNaN(date.getTime())) return "-"; // Check if the date is invalid
  
      const options = { month: "short", day: "numeric", year: "numeric" };
      return date.toLocaleDateString("en-US", options);
    } catch (error) {
      return "-";
    }
  }
  
//   // Example usage:
//   console.log(formatToShortDate("2025-02-20 10:40:36")); // Expected output: "Feb 20, 2025"
//   console.log(formatToShortDate("invalid input")); // Expected output: "-"
  